import React from 'react';

function Profile() {
  return (
    <section id="home" className="intro-profile md-mb50">
      <div className="row rest">
        <div className="col-lg-4 box-img main-bg">
          <div className="cont valign">
            <div className="full-width">
              <div className="img" >
                <img src="/assets/imgs/header/profile.png" alt="" />
                <span className="icon">
                  <img src="/assets/imgs/header/upwork.svg" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/icon2.png" alt="" />
                </span>
                <span className="icon">
                  <img src="/assets/imgs/header/linkedin.svg" alt="" />
                </span>
              </div>
              <div className="info text-center mt-30">
                <h5>Muhammad Hamza</h5>
                <p className="fz-13 text-u">Available For Freelance</p>
              </div>
              {/* <div className="social text-center mt-20">
                <a href="#0">
                  <i className="fab fa-behance"></i>
                </a>
                <a href="#0">
                  <i className="fab fa-github"></i>
                </a>
                <a href="#0">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="#0">
                  <i className="fab fa-dribbble"></i>
                </a>
              </div> */}
            </div>
          </div>
        </div>
        <div className="col-lg-8 content main-bg">
          <h1>
            Hello, I’m <span className="main-color">Muhammad Hamza</span>, a Full-Stack 
            Developer specializing in <span className="bord">SaaS <i></i></span> 
            and AI-Integrated Tools.
          </h1>

          <div className="stauts mt-80">
            <div className="d-flex align-items-center">
              <div className="mr-40">
                <div className="d-flex align-items-center">
                  <h2>6+ </h2>
                  <p>
                    Years <br /> of Experance
                  </p>
                </div>
              </div>
              <div className="mr-40">
                <div className="d-flex align-items-center">
                  <h2>100+ </h2>
                  <p>
                    Projects <br /> Completed
                  </p>
                </div>
              </div>
              <div>
                <div className="butn-presv">
                  <a href="https://calendly.com/muhammadhamza1487/new-meeting" className="butn butn-md butn-bord radius-5 skew" target='_blank'>
                    <span>Book A Meeting</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Profile;
